<template>
  <div class="add-payment-method-form">
    <form @submit.prevent="createPaymentMethod">
      <Field
        label="Billing Name"
        placeholder="Joe Bloggs"
        v-model="name"/>

      <div class="input">
        <label>Card Details</label>
        <div id="card-element" class="card-field"></div>
      </div>

      <Field
        v-if="showDefaultOption"
        label="Set as default"
        v-model="setAsDefault"
        type="checkbox"/>

      <div id="card-errors" role="alert"></div>

      <div class="btn-save">
        <Btn
          primary
          :isLoading="paymentBtnLoading">
          Add Payment Method
        </Btn>
      </div>
    </form>
  </div>
</template>

<script>
import {mapState} from 'vuex'

import Btn from '@/components/Btn'
import Field from '@/components/Field'

export default {
  name: 'create-payment-method-form',

  data() {
    return {
      name: '',
      hasDefaultPaymentMethod: false,
      setAsDefault: true,
      card: {},
      elements: {},
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      style: {
        base: {
          lineHeight: '32px',
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      }
    }
  },

  props: {
    siteId: String,
    companyId: String,
    customer: Object,
    stripe: Object,
    showDefaultOption: Boolean,
    paymentBtnLoading: Boolean
  },

  components: {
    Field,
    Btn
  },

  computed: {
    ...mapState(['currentUser'])
  },

  methods: {
    createCard() {
      this.card = this.elements.create('card', {style: this.style})
      this.mountCard()
    },

    mountCard() {
      this.card.mount('#card-element')
    },

    createPaymentMethod() {
      this.$emit('createPaymentMethod', this.card, this.name, this.setAsDefault)
    }
  },

  mounted() {
    this.name = this.currentUser.name
    this.elements = this.stripe.elements()
    this.createCard()
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.add-payment-method-form
  label
    text-align: left

.card-field
  margin-bottom: $gap-medium
  border: 1px solid $color-border
  border-radius: 3px
  padding-left: 5px
  margin-top: $gap-x-small
</style>
